/**
 * 指挥台：点击路网/等高线成品名称时的飞行
 */
import { message } from './antdMessage';
import { clipBoundsForDisplay } from './mapLayerOverlay';
import { parseMapLayerBounds } from './orthoToolbox';
import { findLatestActiveMember, flyToMemberOnMap } from './dashboard/mapFlyHelpers';

/**
 * @param {object} map
 * @param {object} layer 已发布图层（含 bounds）
 * @param {{ mode?: 'bounds'|'device', members?: array, onStartInteract?: function }} options
 */
export function flyOnOverlayLayerNameClick(map, layer, options = {}) {
  if (!map) {
    message.warning('地图尚未就绪');
    return false;
  }
  const mode = options.mode === 'device' ? 'device' : 'bounds';
  options.onStartInteract?.();

  if (mode === 'device') {
    const member = findLatestActiveMember(options.members || []);
    if (member) {
      const ok = flyToMemberOnMap(map, member, {
        duration: 1600,
        heightMeters: 800
      });
      if (ok) {
        message.success(`已定位到设备：${member.name || '未知'}`);
        return true;
      }
    }
    message.warning('暂无可用设备位置，改为飞到图层范围');
  }

  const wgs = parseMapLayerBounds(layer?.bounds);
  if (!wgs) {
    message.warning(`「${layer?.name || '图层'}」暂无范围数据，无法定位`);
    return false;
  }
  const display = clipBoundsForDisplay(wgs, map) || wgs;
  try {
    map.stop?.();
  } catch (_) { /* ignore */ }
  // 不设 maxZoom，确保市域级范围能完整入画（与勾选叠加时 fitBounds 一致）
  map.fitBounds(
    [[display.west, display.south], [display.east, display.north]],
    {
      padding: 56,
      duration: 900
    }
  );
  message.success(`已定位到「${layer.name || '图层'}」范围`);
  return true;
}
